// src/hooks/useGetDevices.ts

import { useAppSelector } from "../app/hooks";
import { skipToken } from "@reduxjs/toolkit/query";
import { openapi } from "../../openapi";
import { selectGetDevicesArgs } from "../DesignTab/designSlice";
import { IDevice } from "@multiconsult-group/multiplacer-core";

const EMPTY_DEVICES: IDevice[] = [];

export function useGetDevices(): IDevice[] {
  const args = useAppSelector(selectGetDevicesArgs);
  const { data } = openapi.usePostMultiplacerDevicesQuery(args ?? skipToken);
  return data ?? EMPTY_DEVICES;
}
